import React from 'react'

const AdminProfil = () => {
  return (
    <div>AdminProfil</div>
  )
}

export default AdminProfil